import { CuratedPackDetail } from '@bpm-web-app/components/pages';

export default CuratedPackDetail;
